import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Base from '../Base/Base.js';

import { ISuccessMessageConfiguration, ISuccessMessageProps, ISuccessMessageState } from './models/index.js';
import { SUCCESS_MESSAGE_CATEGORY_KEY, SUCCESS_MESSAGE_COMPONENT_KEY } from './SuccessMessage.meta.js';

export class SuccessMessage extends ComponentBase<
	ISuccessMessageProps,
	ISuccessMessageState,
	ISuccessMessageConfiguration
> {
	categoryKey = SUCCESS_MESSAGE_CATEGORY_KEY;
	componentKey = SUCCESS_MESSAGE_COMPONENT_KEY;

	constructor(props: ISuccessMessageProps) {
		super(props);
	}
	render() {
		const { className, children, ...props } = this.props;
		return (
			<Base className={className} {...props}>
				{children}
			</Base>
		);
	}
}

export default InjectedStyledComponent(
	observer(SuccessMessage),
	SUCCESS_MESSAGE_CATEGORY_KEY,
	SUCCESS_MESSAGE_COMPONENT_KEY,
);
